import { Theme } from '@mui/material';

export const MuiPickersLayout = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      borderRadius: '11px',
      backgroundColor: theme.palette.surfaceContainer.high,
      color: theme.palette.surface.onSurfaceVar,
      '& .MuiDayCalendar-weekDayLabel': {
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.surface.onSurfaceVar,
      },
      '& .MuiPickersDay-dayWithMargin': {
        color: theme.palette.surface.onSurfaceVar,
      },
      '& .MuiPickersDay-root.Mui-selected.MuiPickersDay-dayWithMargin': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.onColor,
      },
      '& .MuiPickersDay-dayWithMargin.MuiPickersDay-today': {
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: 'transparent',
      },
      '& .MuiPickersArrowSwitcher-leftArrowIcon': {
        color: theme.palette.surface.onSurfaceVar,
      },
      '& .MuiPickersArrowSwitcher-rightArrowIcon': {
        color: theme.palette.surface.onSurfaceVar,
      },
      '& .MuiPickersYear-yearButton.Mui-selected': {
        backgroundColor: `${theme.palette.primary.main} !important`,
        color: theme.palette.primary.onColor,
      },
    }),
  },
};
